export default "__VITE_ASSET__ed9abac8__"